import { JobQueueState } from "./jobQueueState";
import { JobQueueAction, JobQueueActions } from "./jobQueueActions";
import { JobQueue } from "./jobQueue";

export const jobQueuesReducer = (state: JobQueueState, action: JobQueueActions): JobQueueState => {
  switch (action.type) {
    case JobQueueAction.QueuesLoaded:
      return Object.freeze({
        ...state,
        isLoading: false,
        queues: action.result.reduce((obj, value) => {
            obj[value.id] = value;
            return obj;
          }, {} as { [key: number] : JobQueue })
      });
    case JobQueueAction.QueueUpdated: 
        return Object.freeze({
            ...state,
            queues: {
                ...state.queues,
                [action.queue.id]: action.queue
            },
            showAddQueueModal: false,
            updateJobQueue: null
        })
    case JobQueueAction.ShowAddQueueModal:
        return Object.freeze({
            ...state,
            showAddQueueModal: true
        })
    case JobQueueAction.CloseAddQueueModal:
        return Object.freeze({
            ...state,
            showAddQueueModal: false
        })
    case JobQueueAction.ShowDeleteQueueModal:
        return Object.freeze({
            ...state,
            deleteJobQueue: action.queue,
            showDeleteQueueModal: true,
        })
    case JobQueueAction.CloseDeleteQueueModal:
        return Object.freeze({
            ...state,
            deleteJobQueue: null,
            showDeleteQueueModal: false,
        })
    case JobQueueAction.QueueDeleted:
        const queues = state.queues;
        delete queues[action.id];
        return Object.freeze({  
            ...state,
            queues,
            showDeleteQueueModal: false,
        })
    case JobQueueAction.UpdateFallbackQueue: 
        return Object.freeze({
            ...state,
            updateJobQueue: action.queue
        })
    default:
        throw 'Job Queue Action unhandled'
    }
}
